import Hebcal from 'hebcal';
const myHebcal={
    _functiontocall: undefined,
    getHebDateObject(day, month, year){
        try{
            if( day && month && year){
                var date = new Hebcal.HDate(day+" "+month+" "+year);
                if(date)
                    return date;
            }
        }
        catch(e){
            return null;
        }
    },

    getGregorianDateFromHebrew(day, month, year){
        try{
            let date = this.getHebDateObject(day, month, year).greg()
            if(date)
                return date;
        }
        catch(e){
            return null;
        }
    },

    getCurrentYear(){
        return this.getTodaysDate().toString('h').split(' ')[2];
    },

    getCurrentYearNumber(){
        return this.getTodaysDate().year;
    },

    getTodaysDate(){
        return new Hebcal.HDate(new Date(Date.now()));
    },

    loopFromYearToYear(date_first, numOfYears){
        console.log(date_first);
        date_first = new Hebcal.HDate(date_first);
        let date_arr=date_first.toString('h').split(' ');
        if(date_arr[date_arr.length-1].charAt(0)!="ה")
            date_first = new Hebcal.HDate(date_arr[0]+" "+date_arr[1]+" ה"+date_arr[2]);
        let count=0;
        let this_year_date=new Hebcal.HDate(date_first);
        this_year_date.setFullYear(this.getCurrentYearNumber());
        console.log(this_year_date);
        let allDatesToAdd=[];
       /* for(let i=date_first.year; i<=date_last.year;i++)
        {
            let date = date_first.greg();
            setTimeout(function(_date, _count){
                functiontocall(_date, _count+1);
            },200*count, date, count);
            allDatesToAdd.push(date);
            console.log(date_first.setFullYear(date_first.year+1));
            count++;
        }*/
        for(let i=0; i<numOfYears;i++)
        {
            let date = this_year_date.greg();
            allDatesToAdd.push({'date': date, 'count': this_year_date.year-date_first.year});
            console.log(this_year_date.setFullYear(this_year_date.year+1));
        }
        return (allDatesToAdd);
    },

    yearDifference(date_first, end_year){
        let date_arr=date_first.toString('h').split(' ');
        var date_last = new Hebcal.HDate(date_arr[0]+" "+date_arr[1]+" "+end_year);
        console.log(date_last);
        if(!(date_first.year<=date_last.year)){
            return undefined;
        }
        return date_last.year - date_first.year+1;
    },

    yyyymmdd(date){
        console.log(date);
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        console.log(dd);
      
        return [date.getFullYear(),
                "-",
                (mm>9 ? '' : '0') + mm,
                "-",
                (dd>9 ? '' : '0') + dd
               ].join('');
    }
}

export default myHebcal;




// WEBPACK FOOTER //
// ./src/Codes/myHebcal.js